'use es6';

import styled from 'styled-components';
import { CALYPSO_LIGHT, OBSIDIAN } from 'HubStyleTokens/colors';
import PropTypes from 'prop-types';
import { device } from '../../constants/StyledComponentConstants';
import { jsx as _jsx } from "react/jsx-runtime";
const BannerContainer = styled.div.withConfig({
  displayName: "ColouredBanner__BannerContainer",
  componentId: "sc-1uogzds-0"
})(["background:", ";text-align:center;font-size:1.2em;padding:1em;color:", ";&.clickable{cursor:pointer;}& + div > [class^='UIAbstractPageTemplate'] > section + div{border-top:0;}@media screen and ", "{font-size:1em;}"], CALYPSO_LIGHT, OBSIDIAN, device.mobile);
const ColouredBanner = ({
  onBannerClick,
  children
}) => {
  return /*#__PURE__*/_jsx(BannerContainer, {
    className: onBannerClick ? 'clickable' : '',
    onClick: onBannerClick || null,
    children: children
  });
};
ColouredBanner.propTypes = {
  children: PropTypes.node.isRequired,
  onBannerClick: PropTypes.func
};
export default ColouredBanner;